import { z } from 'zod';
import { requiredFieldError, requiredString } from '../../helper';
import { PaymentFunds } from '../../types';

export const repaymentAccount = z.object({
  methodId: requiredString(),
});

export const repaymentAccountSource = z.object({
  source: z.nativeEnum(PaymentFunds, { required_error: requiredFieldError() }),
});
